<template>
    <div class="MenuPanel">
        <div class="Menu__panel"
            :style="[
                functionalityStyle,
                positionStyle,
                (isTranslating) ? transitionStyle : {}
            ]"
        >
            <div v-if="list.meta && list.meta.label" @click="handleHeaderClicked" class="Menu__header flex items-center px-4 py-3 cursor-pointer bg-gray-600 text-white">
                <LeftArrowIcon v-show="showHeaderArrow" />
                <div class="ml-2 uppercase text-xs tracking-widest">{{ list.meta.label }}</div>
            </div>

            <ul class="Menu__list overflow-x-auto" :style="menuListHeight">
                <li
                    class="Menu__item flex items-center px-4 py-3"
                    v-if="loading"
                ><app-spinner class="text-gray-500" /> <span class="ml-3">Loading...</span></li>
                <template v-else>
                    <li v-for="item in items"
                        :key="item.path"
                        @click="handleItemClicked(item)"
                        class="Menu__item flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-300"
                        :class="{'bg-gray-300': $route.name === item.name, [item.meta.cssClass]: item.meta.cssClass}"
                    >
                        <template v-if="item.children">
                            <div class="ml-2 uppercase text-xs tracking-widest">{{ item.meta.label }}</div>
                            <span class="arrow">
                                <RightArrowIcon />
                            </span>
                        </template>
                        <a v-else>
                            <div class="ml-2 uppercase text-xs tracking-widest">{{ item.meta.label }}</div>
                        </a>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    components: {
        RightArrowIcon: () => import('@/icons/ArrowRight'),
        LeftArrowIcon: () => import('@/icons/ArrowLeft'),
    },
    props: {
        list: {
            type: Array|Object,
            required: true,
        },
        positionStyle: {
            type: Object,
            required: true,
        },
        showHeaderArrow: {
            type: Boolean,
            default: false,
        },
        isTranslating: {
            type: Boolean,
            default: false,
        },
        handleHeaderClicked: {
            type: Function,
            default: () => {},
        },
        handleItemClicked: {
            type: Function,
            default: () => {},
        },

        // @TODO: create createMenuPanel.js to assign `functionalityStyle` which is not diff from next, staging, and prev panel in parent component.
        functionalityStyle: {
            type: Object,
            required: true,
        },
        transitionStyle: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        items() {
            if (Array.isArray(this.list)) {
                return this.list;
            }

            return this.list.children;
        },
        menuListHeight() {
            if (this.list.meta && this.list.meta.label) {
                return {height: 'calc(100% - 48px)'};                
            }

            return {height: '100%'};
        }
    },
};
</script>